import isScrollbar from './_import/_isScrollbar'
import focusVisible from './_polyfill/focus-visible'
isScrollbar.init()

if (!focusVisible.hasFocusVisible()) {
  // safari 15.4未満はfocus-visible非対応
  focusVisible.init()
}
